import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Popular.css";
import { useProductStore } from "../../stores/useProductStores";

const TrendingProducts = () => {
  const { trendingProducts, getTrendingProducts } = useProductStore();
  const navigate = useNavigate();

  useEffect(() => {
    getTrendingProducts();
  }, [getTrendingProducts]);

  console.log("Rendered Trending products:", trendingProducts);

  return (
    <div className="september-selections">
      <h2 className="title">TRENDING</h2>
      <p className="subtitle">Explore our popular designs  <hr/> </p>
      <div className="grid-container">
        {trendingProducts.length > 0 ? (
          trendingProducts.slice(0, 3).map((product) => ( // Only display 3 products
            <div
              key={product.id}
              className="card"
              onClick={() => navigate(`/product/${product.id}`)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={product.image}
                alt={product.name}
                className="card-image"
                 loading="lazy"
                 decoding="async"
              />
              <div className="card-label">{product.name}</div>
              {Number(product.available_quantity ?? 0) <= 0 && (
                <div className="card-stock-label">Out of stock</div>
              )}
              {Number(product.available_quantity ?? 0) > 0 &&
                Number(product.available_quantity) <= 2 && (
                  <div className="card-stock-label">
                    Only {product.available_quantity} left
                  </div>
                )}
            </div>
          ))
        ) : (
          <p>Loading Trending Products...</p>
        )}
      </div>
    </div>
  );
};

export default TrendingProducts;
